<template>
    <div>
        <button
            class="btn btn-outline-dark"
            @click="currentFeedbackPage = 1;getFeedbacks();showFeedbacks = !showFeedbacks"
        >View Student Feedbacks</button>
        <br />
        <div v-if="showFeedbacks">
            <br />
            <div
                style="display:flex;flex-direction:column;align-items:center;justify-content:center"
            >
                <b-input-group style="width:50vw">
                    <b-form-rating v-model="feedbackAvg" show-value readonly></b-form-rating>
                    <b-input-group-append>
                        <b-input-group-text
                            class="justify-content-center"
                        >From {{ feedbackCount }} feedbacks</b-input-group-text>
                    </b-input-group-append>
                </b-input-group>
            </div>
            <nav class="mt-3">
                <ul class="pagination justify-content-center">
                    <li :class="['page-item',currentFeedbackPage == 1 ? 'disabled':'']">
                        <a class="page-link" @click="currentFeedbackPage--; getFeedbacks()">Previous</a>
                    </li>
                    <li
                        :class="[currentFeedbackPage == i ? 'active' : '', 'page-item']"
                        v-for="i in feedbacks.length"
                    >
                        <a class="page-link" @click="currentFeedbackPage=i; getFeedbacks()">{{ i }}</a>
                    </li>
                    <li :class="['page-item',currentFeedbackPage == pageCount ? 'disabled':'']">
                        <a class="page-link" @click="currentFeedbackPage += 1; getFeedbacks()">Next</a>
                    </li>
                </ul>
            </nav>
            <br />
            <table class="table">
                <thead>
                    <tr>
                        <th>Date Created</th>
                        <th>Student</th>
                        <th>Class</th>
                        <th>Teacher</th>
                        <th>Rating</th>
                        <th>Comments</th>
                    </tr>
                </thead>
                <tbody>
                    <tr
                        v-for="feedback in feedbacks[currentFeedbackPage-1]"
                    >
                        <td>{{ feedback.timestamp | toDate }}</td>
                        <td>{{ feedback.student }}</td>
                        <td>{{ feedback.class }}</td>
                        <td>{{ feedback.teacher }}</td>
                        <td>{{ feedback.rating }}</td>
                        <td>{{ feedback.comments }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
const fb = require("../../firebaseConfig");
export default {
    data() {
        return {
            showFeedbacks: false,
            currentFeedbackPage: null,
            feedbackCount: 0,
            pageCount: 0,
            feedbackAvg: 0,
            lastFeedback: null,
            feedbacks: []
        };
    },
    methods: {
        async getFeedbacks() {
            if (this.feedbacks.length == 0) {
                fb.db
                    .collection("misc")
                    .doc("feedbackStats")
                    .get()
                    .then(doc => {
                        const data = doc.data();
                        this.feedbackCount = data.count;
                        this.feedbackAvg = (
                            data.totalRating / this.feedbackCount
                        ).toFixed(2);
                        this.pageCount = Math.ceil(this.feedbackCount / 10);
                    });
                const firstBatch = [];
                await fb.db
                    .collection("feedbacks")
                    .orderBy("timestamp", "desc")
                    .limit(10)
                    .get()
                    .then(querySnapshot => {
                        querySnapshot.forEach((doc, i) => {
                            firstBatch.push(doc.data());
                        });
                        this.lastFeedback =
                            querySnapshot.docs[querySnapshot.docs.length - 1];
                    });
                this.feedbacks.push(firstBatch);
            }
            if (this.feedbacks.length >= this.currentFeedbackPage) return;
            const nextBatch = [];
            fb.db
                .collection("feedbacks")
                .orderBy("timestamp", "desc")
                .startAfter(this.lastFeedback)
                .limit(10)
                .get()
                .then(querySnapshot => {
                    querySnapshot.forEach(doc => {
                        nextBatch.push(doc.data());
                    });
                    this.lastFeedback =
                        querySnapshot.docs[querySnapshot.docs.length - 1];
                });
            this.feedbacks.push(nextBatch);
        }
    },
    filters: {
        toDate(a) {
            return a
                .toDate()
                .toString()
                .slice(4, 16);
        }
    }
};
</script>